(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('Seduta', Seduta);

    Seduta.$inject = ['$resource', 'Upload', 'DateUtils', '$http'];

    function Seduta ($resource, Upload, DateUtils, $http) {
        var resourceUrl =  'api/sedutas/:id/:typeOrg/:idOrg/:organismiUtente/:numero/:transizione/:nextStateName/:puntiAffariTrattati/:ordineDelGiorno/:idOdgDoc/:files/:protocolNow/:filingcode/:idDoc';

        var resource = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataDiConvocazione = DateUtils.convertDateTimeFromServer(data.dataDiConvocazione);
                    }
                    return data;
                }
            },
            'saveWithWB' : {
                method: 'POST'
            },
            'update': { method:'PUT' },
            'organismiUtente' : {
                method: 'GET',
                params: {organismiUtente: 'organismiUtente'},
                isArray: true
            },
            'organismiSeduta' : {
                method: 'GET',
                params: {organismiUtente: 'organismi'},
                isArray: true
            },
            'nextNumeroSeduta' : {
                method: 'GET',
                params: {
                    numero : 'numero'
                }
            },
            'sedutaStateTransition' : {
                method : 'PUT',
                params : {
                    transizione: 'transizione'
                }
            },
            'getPuntiAffariTrattatiSeduta': {
                method: 'GET',
                params : {
                    puntiAffariTrattati: 'punti-affari-trattati'
                },
                isArray : true
            },
            'getSedutaDocuments': {
                method: 'GET',
                params : {
                    files: 'files'                    
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    var result = [];
                    var lastGroup = null;
                    if (data && (!data.status || data.status === 200)) {
                        angular.forEach(data, function (doc) {
                            if (lastGroup === null || lastGroup.name !== doc.gruppoProtocollo) {
                                lastGroup = {
                                    name: doc.gruppoProtocollo,
                                    protocolState: doc.statoProtocollo,
                                    mittenti: doc.mittentiProtocollo || [],
                                    destinatari: doc.destinatariProtocollo || [],
                                    documents: [],
                                    operatingOffice: doc.operatingOffice
                                };
                                result.push(lastGroup);
                            }
                            doc.name = doc.nome;
                            doc.public = doc.pubblico;
                            doc.frontpiece = doc.frontespizio;
                            doc.protocolState = doc.statoProtocollo;
                            doc.protocolGroup = doc.gruppoProtocollo;
                            doc.docType = doc.tipoDocumento.tipo;
                            lastGroup.documents.push(doc);
                        });
                    }
                    return { data: result };
                }
            },
            'protocolNow': {
                method: 'POST',
                params: {
                    ordineDelGiorno: 'ordine-del-giorno',
                    files: 'files',
                    protocolNow: 'protocolNow'
                },
                isArray: true
            },
            'getFilingCode': {
                method: 'GET',
                params: {
                    filingcode: 'filingcode',
                },
                transformResponse: function (data) {
                    return { data: data };
                }
            },
            'updateDocument' : {
                method : 'PUT',
                params : {
                    files: 'files'
                },
                isArray: true
            }
        });

        resource.uploadFileSeduta = function (idSeduta, file, params) {
            return Upload.upload({
                url: 'api/sedutas/' + idSeduta + '/files',
                method: 'POST',
                data: params || {},
                file: file,
            });
        };

        resource.updateFileProtocolData = function (idSeduta, idOdgPar, fileList) {
            var params = {idOdg : idOdgPar};
            return $http.put('api/sedutas/' + idSeduta + '/files', fileList, params).then(
                function (response) {
                    // success callback
                    console.log("Success: ", response);
                },
                function (response) {
                    // failure callback
                    console.log("Failure: ", response);
                });
        };

        resource.getAffariTrattatiPDFReport = function (idSeduta) {
            return $http.get('/api/sedutas/' + idSeduta + '/affariTrattatiReport',
                { responseType: 'arraybuffer' });
        };

        return resource;
    }
})();
